import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
export default function NotFound() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Page not found"
          title="Let’s get you back on track."
        >
          <p>The page may have moved, or the address may be incorrect.</p>
          <Link className="button button-green" to="/">
            Return Home ↗
          </Link>
        </PageIntro>
      </main>
      <Footer />
    </>
  );
}
